export default {
  hero: {
    badge: "Powered by Otovo",
    tagline: "Solar panel leasing",
    headline: {
      before: "Solar from a fixed ",
      highlight: "monthly",
      after: " payment",
    },
    title: "Solar leasing for homeowners",
    description:
      "No upfront cost. Installation, maintenance, and warranty included.",
    cta: "Get my solar estimate",
    "monthly-payment": {
      title: "Monthly Payment",
      price: "€XX/mo",
      subtitle: "All-inclusive solar subscription.",
      noUpfront: "No upfront",
      autoPay: "Auto-pay",
      protected: "Protected",
    },
  },
  solutions: {
    headline: {
      before: "A smarter way to go ",
      highlight: "solar",
      after: "",
    },
    subtitle:
      "All the benefits of solar without the traditional barriers.",
    cards: {
      noUpfront: {
        title: "No upfront investment",
        description:
          "Start solar without paying thousands upfront.",
      },
      fixedPayment: {
        title: "Fixed monthly payment",
        description: "One predictable payment every month.",
      },
      allInclusive: {
        title: "All-inclusive service",
        description:
          "Installation, maintenance, and warranty included.",
      },
      optionToBuy: {
        title: "Option to buy later",
        description: "Purchase the system after 10 years.",
      },
    },
  },
  comparison: {
    headline: {
      before: "",
      highlight: "Leasing",
      after: " or buying: what's the difference?",
    },
    buyingColumn: "Buying solar",
    leasingColumn: "Solar leasing",
    criteria: "Criteria",
    rows: {
      upfrontCost: {
        criteria: "Upfront cost",
        buying: "High",
        leasing: "None",
      },
      monthlyCost: {
        criteria: "Monthly cost",
        buying: "None",
        leasing: "Fixed monthly fee",
      },
      maintenance: {
        criteria: "Maintenance",
        buying: "Your cost",
        leasing: "Included",
      },
      warranty: {
        criteria: "Warranty",
        buying: "Limited",
        leasing: "Full coverage",
      },
      flexibility: {
        criteria: "Flexibility",
        buying: "Low",
        leasing: "Buy after 10 years",
      },
    },
  },
  "how-it-works": {
    title: "How it works",
    subtitle:
      "With leasing, you never worry about surprise costs. From installation to long-term maintenance, it's all covered.",
    steps: {
      requestOffer: {
        title: "Request your offer",
        subtitle: "Tell us about your home and energy needs.",
      },
      getApproved: {
        title: "Get approved",
        subtitle: "We check your eligibility for leasing.",
      },
      installation: {
        title: "Installation",
        subtitle: "Your system is installed by professionals.",
      },
      startSaving: {
        title: "Start saving",
        subtitle: "Pay monthly and reduce your electricity bills.",
      },
    },
  },
  "everything-included": {
    title: "Everything is included",
    today: "Today",
    month: "Month",
    cards: {
      solarPanels: {
        title: "Solar panels and inverter",
        subtitle:
          "Premium equipment from leading manufacturers with industry-best efficiency ratings.",
      },
      monitoring: {
        title: "24/7 Monitoring",
        subtitle:
          "Track your system's performance in real-time with our advanced monitoring platform.",
        "bullet-1": "Live performance data",
        "bullet-2": "Instant alerts"
      },
      energyProduction: {
        title: "Energy production",
        subtitle: "View your monthly production at a glance.",
      },
      professionalInstallation: {
        title: "Professional installation",
        subtitle: "Certified technicians ensure quality work.",
      },
      permits: {
        title: "Permits and paperwork",
        subtitle: "We handle all documentation and approvals.",
      },
      maintenance: {
        title: "Maintenance and repairs",
        subtitle:
          "All routine maintenance and unexpected fixes covered throughout the lease.",
      },
      warranty: {
        title: "Full warranty coverage",
        subtitle: "Complete protection for your solar system.",
      },
    },
  },
  "flexible-over-time": {
    title: "Flexible over time",
    cards: {
      buyAfter10: {
        title: "Buy your system after 10 years",
        description: "Own your solar system for a fixed price.",
      },
      transferContract: {
        title: "Transfer contract when selling",
        description: "Pass the lease to the new homeowner.",
      },
      upgradeLater: {
        title: "Upgrade your system later",
        description: "Add batteries or expand capacity.",
      },
    },
  },
  cta: {
    title: "Check your solar eligibility",
    subtitle: "Get a personalized solar offer in just a few steps.",
    features: {
      noCreditCheck: "No credit check required to start",
      quickProcess: "Quick 5-minute process",
      noObligation: "No obligation",
    },
    buttonPrimary: "Get my estimate",
  },
  installer: {
    hero: {
      badge: "Powered by Otovo",
      headline: {
        before: "Stop losing deals at pricing. Start selling ",
        highlight: "monthly solar",
        after: "",
      },
      description:
        "Offer your clients a full PV system with zero upfront payment, approved in under 24 hours.",
      benefits: {
        "no-upfront": "No upfront cost",
        "acceptance-rate": "90% acceptance rate",
        "approval-24h": "Approval in under 24h",
        "no-bank-loan": "No bank loan required",
        "no-borrowing-impact": "No impact on borrowing capacity",
        "fixed-payments": "Fixed monthly payments",
      },
      "cta-learn-more": "Learn More",
      "cta-book-demo": "Book a demo",
      tagline: "You install. We finance. Get paid normally for every project.",
      card: {
        title: "Offer your customers solar subscriptions and unlock upto",
        stats: {
          "additional-projects": "Additional projects/year",
          "additional-revenue": "Additional annual revenue",
          "conversion-uplift": "Conversion rate uplift",
        },
        "installations-per-year": "Installations per year",
        "slider-min": "5",
        "slider-max": "50",
        "customize-projections": "Customize projections to your specific business",
        "how-we-calculate": "How we calculate this number",
        "discover-revenues": "Discover how we calculate your revenues",
      },
    },
    "lost-deals": {
      title: "How many projects are lost because of financing?",
      subtitle:
        "Many residential customers hesitate at the final step. Not because they do not want solar, but because:",
      painPoints: {
        "high-investment": "The upfront investment is too high",
        "bank-loans-slow": "Bank loans take too long",
        "borrowing-limited": "Borrowing capacity is already limited",
        "approval-uncertain": "Approval is uncertain",
      },
    },
    benefits: {
      title: "The Benefits of Leasing for Installers",
      subtitle: "Grow your business with a competitive advantage",
      stats: {
        "close-rate": {
          value: "45%",
          title: "Average increase in close rate",
          description: "Convert more leads by removing the upfront cost barrier",
        },
        "system-size": {
          value: "2x",
          title: "Larger average system size",
          description: "Customers can afford larger installations thanks to monthly payments.",
        },
        "faster-sales": {
          value: "3x",
          title: "Faster sales",
          description: "Close deals in days, not months waiting for customer financing",
        },
        satisfaction: {
          value: "100%",
          title: "Customer satisfaction",
          description: "Match big installers with professional financing options",
        },
      },
    },
    "deal-flow": {
      headline: {
        before: "From lost deals to ",
        highlight: "closed",
        after: " projects",
        "highlight-2": "",
      },
      subtitle:
        "See how offering monthly solar subscriptions can transform your sales funnel without changing your workflow.",
      "image-alt": "Deal flow comparison: from lost deals to closed projects",
      left: {
        title: "Loan (classic financing)",
        items: {
          "approval-rate": {
            label: "Approval rate",
            value: "Low / uncertain",
          },
          "approval-delay": {
            label: "Approval timeline",
            value: "Days to weeks",
          },
          "commercial-friction": {
            label: "Commercial friction",
            value: "High (bank, paperwork, hesitation)",
          },
          "customer-objections": {
            label: "Customer objections",
            value: "\"I need to check with my bank\"",
          },
          "debt-impact": {
            label: "Impact on customers' debt",
            value: "Increases the debt ratio",
          },
          "sales-cycle": {
            label: "Sales cycle duration",
            value: "Long and unpredictable",
          },
          "drop-off-rate": {
            label: "Drop-off rate",
            value: "High",
          },
          "offer-attractiveness": {
            label: "Offer attractiveness",
            value: "Standard",
          },
          "closing-speed": {
            label: "Closing speed",
            value: "Slow",
          },
          "rare-deal": {
            label: "Rare deal",
            description: "Delays or cancellations on the customer side",
          },
        },
      },
      right: {
        title: "Leasing",
        items: {
          "approval-rate": {
            label: "Approval rate",
            value: "Approved at 90 %",
          },
          "approval-delay": {
            label: "Approval timeline",
            value: "<24h",
          },
          "commercial-friction": {
            label: "Commercial friction",
            value: "Low (simple eligibility checks)",
          },
          "customer-objections": {
            label: "Customer objections",
            value: "Almost none",
          },
          "debt-impact": {
            label: "Impact on customers' debt",
            value: "No impact on debt (treated as rent)",
          },
          "sales-cycle": {
            label: "Sales cycle duration",
            value: "Fast and controlled",
          },
          "drop-off-rate": {
            label: "Drop-off rate",
            value: "Considerably reduced",
          },
          "offer-attractiveness": {
            label: "Offer attractiveness",
            value:
              "\"€ 0 deposit\" = trigger factor for a high conversion rate",
          },
          "closing-speed": {
            label: "Closing speed",
            value: "Same-day or next-day closing",
          },
        },
        final: {
          title: "Deal closed",
          description: "The customer signs with confidence",
        },
      },
    },
    "how-it-works": {
      title: "How it works",
      subtitle:
        "With the rental contract, you never have to worry about unforeseen costs. From installation to long-term maintenance, everything is covered.",
      steps: {
        "request-rental": {
          title: "Request a rental",
          subtitle: "Request access to the rental contract integration.",
        },
        "get-verified": {
          title: "Get verified",
          subtitle: "We verify your installer profile and your references.",
        },
        "offer-leasing": {
          title: "Propose rental contracts in offers",
          subtitle: "The rental contract automatically appears in your financial simulations.",
        },
        "close-contracts": {
          title: "Close more contracts",
          subtitle: "Offer your clients flexible payment options.",
        },
      },
    },
    "requirements-comparison": {
      left: {
        title: "Install requirements",
        items: {
          certification: "Certification",
          "insurance-coverage": "Insurance coverage",
          "company-registration": "Company registration",
          ursaf: "URSSAF",
          "identity-document": "Identity document",
          "bank-details": "Bank details",
          "framework-contract-signed": "Framework contract signed",
        },
      },
      right: {
        title: "Customer requirements",
        items: {
          "valid-id": "Valid ID",
          "last-3-payslip": "Last 3 payslip",
          "property-tax-document": "Property tax document",
        },
      },
    },
    "partner-requirements": {
      title: "Partner requirements",
      requirements: {
        "certified-installer": {
          title: "Certified installer",
          description: "Valid certification and license for solar installation.",
        },
        "insurance-coverage": {
          title: "Insurance coverage",
          description: "Adequate civil liability insurance and workers' compensation insurance.",
        },
        "proven-quality": {
          title: "Proven experience in quality",
          description: "Demonstrated history of successful installations.",
        },
        "otovo-access": {
          title: "Access to the Otovo platform",
          description: "You do this via the integration of our portal into your projetsolaire account.",
        },
      },
    },
  },
}
